- const fixture = require('./fixture.jade')
- const { parent } = properties
- const data = parent.data[parent.api].liveFeed
- const {
-   events,
-   columns,
-   page,
-   perPage,
-   loading,
-   fixture: fixtureData,
-   fixtureColumns
- } = data
- const total = (parent.filteredLiveEvents || []).flat().length

if !loading && !events.length
  h2.no-data No data

else if loading
  h2.loading Loading...

else
  +fixture.minimal(
    parent=parent,
    fixture=fixtureData,
    columns=fixtureColumns[parent.sport]
  )

  .filters
    .item
      label Map name
      ft-form-control(
        placeholder='Map name',
        type='text',
        [(value)]=data.filter.mapName,
        (input)=parent.filterOn('liveFeed', 'mapName', e.target.value)
      )
    .item
      label Map #
      ft-form-control(
        placeholder='Map #',
        type='number',
        [(value)]=data.filter.mapNumber,
        (input)=parent.filterOn('liveFeed', 'mapNumber', e.target.value)
      )
    .item
      label Half #
      ft-form-control(
        placeholder='Half',
        type='number',
        [(value)]=data.filter.halfNumber,
        (input)=parent.filterOn('liveFeed', 'halfNumber', e.target.value)
      )
    .item
      label Round #
      ft-form-control(
        placeholder='Round',
        type='number',
        [(value)]=data.filter.roundNumber,
        (input)=parent.filterOn('liveFeed', 'roundNumber', e.target.value)
      )
    .item
      label Event name
      ft-form-control(
        placeholder='Event name',
        type='text',
        [(value)]=data.filter.name,
        (input)=parent.filterOn('liveFeed', 'name', e.target.value)
      )
    .item
      label Weapon
      ft-form-control(
        placeholder='Weapon',
        type='text',
        [(value)]=data.filter.weapon,
        (input)=parent.filterOn('liveFeed', 'weapon', e.target.value)
      )
    .item
      label Killer
      ft-form-control(
        placeholder='Killer',
        type='text',
        [(value)]=data.filter.killer,
        (input)=parent.filterOn('liveFeed', 'killer', e.target.value)
      )
    .item
      label Victim
      ft-form-control(
        placeholder='Victim',
        type='text',
        [(value)]=data.filter.victim,
        (input)=parent.filterOn('liveFeed', 'victim', e.target.value)
      )
    .item
      label Assister
      ft-form-control(
        placeholder='Assister',
        type='text',
        [(value)]=data.filter.assister,
        (input)=parent.filterOn('liveFeed', 'assister', e.target.value)
      )
    .item
      label Defuser
      ft-form-control(
        placeholder='Defuser',
        type='text',
        [(value)]=data.filter.defuserName,
        (input)=parent.filterOn('liveFeed', 'defuserName', e.target.value)
      )
    .item
      ft-button(
        danger,
        (click)=parent.resetFilter('liveFeed')
      ) Reset
    .item
      label Total rows
      span= total
    .item
      ft-button.pause(
        warning=data.paused,
        primary=!data.paused,
        (click)=parent.pauseFeed()
      )= data.paused ? 'Resume Feed' : 'Pause Feed'

  table.live-feed
    thead
      th
        each column in Object.keys(columns[parent.sport])
          td: span= columns[parent.sport][column]
    tbody
      each row, index in parent.filteredLiveEvents[page]
        - const eventClass = parent.eventClass(row)
        tr
          if parent.sport === 'csgo' && parent.api === 'gamescorekeeper'
            td.index: span= row.index
            td: span= row.mapNumber
            td: span= row.halfNumber
            td: span= row.roundNumber
            td: span= parent.moment(row.timestamp).format(parent.timestampFormat)
            td.event-name(class=eventClass): span= row.name
            td: span= row.mapName
            td: span= row.winnerId
            td: span= row.sourceTeamId
            td: span= row.targetTeamId
            td: span= row.planterId
            td: span= row.planterName
            td: span= row.defuserId
            td: span= row.defuserName
            td: span= row.weapon
            td: span
              if row.name === 'kill'
                if row.headshot === true
                  | yes
                else if row.headshot === false
                  | no
            td
              section(class=parent.side(row.killer))
                each key in Object.keys(row.killer || {})
                  span= `${key}: ${row.killer[key]}`
            td
              section(class=parent.side(row.victim))
                each key in Object.keys(row.victim || {})
                  span= `${key}: ${row.victim[key]}`
            td
              section(style=`background: var(--${color}); color: var(--${color}-text)`)
                each key in Object.keys(row.assister || {})
                  span= `${key}: ${row.assister[key]}`
            td
              each participant in row.participants || []
                section
                  each key in Object.keys(participant || {})
                    span= `${key}: ${participant[key]}`

  ft-pagination(
    primary=true,
    display=4,
    current=page,
    (currentChanged)=parent.setPage(e.target.current, 'liveFeed'),
    size=perPage,
    total=total
  )